module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-mag-eb90bdac79f9138862dfa5574d3c0d15.jpg";